import { render, staticRenderFns } from "./SsoLg.vue?vue&type=template&id=4c4047b7&scoped=true"
import script from "./SsoLg.vue?vue&type=script&lang=js"
export * from "./SsoLg.vue?vue&type=script&lang=js"
import style0 from "./SsoLg.vue?vue&type=style&index=0&id=4c4047b7&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4047b7",
  null
  
)

export default component.exports